<template>
  <div class="card-item">
    <div class="card-item-descricao">
      <!-- titulo  -->
      <!-- essa logica abaixo existe para centralizar o titulo do item  -->
      <!-- verticalmente caso nao existam variacoes e nem ficha tecnica -->

      <!-- <p style="color: red;">{{ JSON.stringify(item.indexDaEtapa) }}</p> -->

      <h4
        v-if="item.adicionar != null || item.retirar != null"
        class="nome-item"
      >
        {{ temSubitem ? nomeItem() : item.nome }}
      </h4>

      <h4
        v-if="item.adicionar == null && item.retirar == null"
        class="nome-item"
      >
        {{ temSubitem ? nomeItem() : item.nome }}
      </h4>

      <!-- verificar se tem pergunta forcada  -->
      <div
        v-if="
          item.perguntasForcadas != null && item.perguntasForcadas.length > 0
        "
      >
        <p
          class="texto-sem"
          v-for="(elem, index) in item.perguntasForcadas"
          :key="index"
        >
          {{ elem.opcaoEscolhida }}
        </p>
      </div>

      <!-- verificar se tem observacao de prepado da classe  --> 
      <div v-if="item.observacoes != null && item.observacoes.length > 0">
        <p
          class="texto-sem"
          v-for="(elem, index) in item.observacoes"
          :key="index"
        >
          {{ elem }}
        </p>
      </div>

      <!-- verificar se tem fichatecnica, escrever SEM + nome do item  -->
      <div v-if="item.retirar != null && item.retirar.length > 0">
        <p class="texto-sem" v-for="(elem, index) in item.retirar" :key="index">
          {{ "SEM " + elem.nome }}
        </p>
      </div>

      <!-- verificar se tem VARIACAO fichatecnica, e escrever COM + nome do item  -->
      <div v-if="item.adicionar != null && item.adicionar.length > 0">
        <div
          class="texto-sem"
          v-for="(elem, index) in item.adicionar"
          :key="index"
        >
          <div v-for="(item, index) in mostraQtdAgrupada(elem)" :key="index">
            <p>
              {{ item }}
            </p>
          </div>
        </div>
        <br />
      </div>
      <!-- <p>{{ item }}</p> -->
    </div>

    <!-- quantidade  -->
    <div class="card-item-quantidade">
      <p >x{{ quantidadeComputed }}</p>
    </div>

    <!-- precos  -->
    <div class="card-item-precos">
      <div style="flex: 1;" v-if="quantidadeComputed>1">
        <div class="container-un-to" style="background: darkBlue;flex: 1;">Un</div>
        <p style="color: darkBlue">
          R$ {{ this.precoUnitarioComputed.toFixed(2).replace(".", ",") }}
        </p>
      </div>
      <div style='flex: 1;' v-if="this.precoTotalComputed">
        <div class="container-un-to" style="background: darkGreen">Tot</div>
        <p style="color: darkGreen">
          R$ {{ this.precoTotalComputed.toFixed(2).replace(".", ",") }}
        </p>
      </div>
    </div>

    <button class="card-item-btn-editar" @click="clicouEditar">
      <img src="../../assets/icons/editar.png" alt="" class="img-trash" />
    </button>
    <!-- botao excluir  -->
    <button class="card-item-btn-excluir" @click="clicouExcluir">
      <img src="../../assets/icons/ic-trash.png" alt="" class="img-trash" />
    </button>
  </div>
</template>

<script>
export default {
  name: "CardItemCarrinho",
  props: {
    item: Object, // caso seja combo, esse item sera um subitem do combo
    combo: Object, // esse objeto vem so para necessidade de excluir um combo, precisamos saber o codigo do combo e nao do subitem
    temSubitem: Boolean,
    onExcluir: Function,
    onEditar: Function,
    // etapaIndex:
  },
  created() {
    this.consolo();
  },
  computed: {
		quantidadeComputed() {
			if (this.item.fracaoQuantidade) {
        if (this.item.fracaoQuantidade == 1 || this.item.fracaoQuantidade == "1") return 1
				return "1/" +this.item.fracaoQuantidade
			}
			if (this.item.quantidadeCombo != null) {
        return this.item.quantidadeCombo;
			}
			return this.item.quantidade;
		},
    
		precoUnitarioComputed() {
      if (this.item.tipo == "produto") {
        if (this.item.preco == null) return 0.0;
				if (this.item.precoApenasVariacoes == null) return 0.0;
        if (this.item.precoSaborMaisCaro) {
          return this.item.precoSaborMaisCaro + this.item.precoApenasVariacoes;
        }
				return this.item.preco + this.item.precoApenasVariacoes;
			}
			if (this.item.item != null && this.item.item.valorVendaItem != null) {
        return this.item.item.valorVendaItem;
			}
			return this.item.precoTotal;
		},
    
		precoTotalComputed() {
      let precoAqui = 0.0;
			if (this.item.tipo == "produto") {
        if (this.item.preco == null) return 0.0;
				if (this.item.precoApenasVariacoes == null) return 0.0;
				if (this.item.fracaoQuantidade) {
          if (this.item.precoSaborMaisCaro) {
            return (this.item.precoSaborMaisCaro + this.item.precoApenasVariacoes) * this.item.quantidade;
          }
          return (this.item.preco + this.item.precoApenasVariacoes) * 1/this.item.fracaoQuantidade;
        }
				// subitem de comboVendaConjunta: a quantidade de fato vem em quantidadeCombo,
				// this.item.quantidade fica travado em 1 no ProdutoController (ver comentário lá)
				const quantidadeReal = this.item.quantidadeCombo ?? this.item.quantidade;
				return (this.item.preco + this.item.precoApenasVariacoes) * quantidadeReal;
			}
			if (this.item.item != null && this.item.item.valorVendaItem != null) {
				precoAqui = this.item.item.valorVendaItem;
			} else {
				precoAqui = this.item.precoTotal;
			}
			if (this.item.quantidadeCombo != null) {
				return precoAqui * this.item.quantidadeCombo;
			}
			return precoAqui * this.item.quantidade;
		},
  },
  methods: {
    mostraQtdAgrupada(lista) {
      const count = {};
      lista.opcoesEscolhidas.forEach(({ nome }) => {
        count[nome] = (count[nome] || 0) + 1;
      }); 

      return Object.entries(count).map(
        ([nome, quantidade]) => `+${quantidade}x ${nome}`
      );
    },
    consolo() {
      console.log("---------------- Card Item Carrinho --------------------------------");
      console.log((this.combo)); 
      console.log("____________________________________________________________________");
    },

    clicouExcluir() {
      if (this.temSubitem) {
        this.onExcluir(this.combo);
      } else {
        this.onExcluir(this.item);
      }
    },

    clicouEditar() {
      // console.log("index editado: " + this.item.indexDaEtapa);
      if (this.temSubitem) {
        let comboComIndexDoEditado = this.combo;
        comboComIndexDoEditado.indexDaEtapa = this.item.indexDaEtapa;
        this.onEditar(comboComIndexDoEditado);
      } else {
        this.onEditar(this.item);
      }
    },

    nomeItem() {
      if (this.item.nome == null) {
        return this.item.descricao;
      } else {
        return this.item.nome;
      }
    },
  },
};
</script>

<style scoped>
/* GERAL  */
.centralize,
.card-item-descricao,
.card-item-quantidade {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  max-height: 100%;
}

/* WIDTHS  */
.card-item-descricao {
  width: 50%;
  padding: var(--padding-padrao);
}
.card-item-quantidade {
  width: 10%;
}
.card-item-precos {
  width: 30%;
}
.card-item-btn-editar {
  width: 10%;
}

.card-item-btn-excluir {
  width: 10%;
}

/* RESTO  */

.loading {
  margin-top: 120px;
  margin-inline: auto;
}

.bods {
  background: white;
}

.background-brancos {
  border: solid 10px var(--primaryDark_azul);
}

.top-bar {
  background: white;
  margin-top: 5px;
}

.nome-item {
  font-size: 12px;
  align-content: center;
  align-items: center;
}

.container-cards {
  background: white;
  overflow-y: auto;
  flex: 1;
}

.bottom-bar {
  margin-top: 65px;
  background: white;
  margin-bottom: 5px;
}

.precoTotal > div {
  animation: precoTotalAnim 1s forwards;
}

@keyframes precoTotalAnim {
  0% {
    opacity: 0;
    background: green;
  }
  100% {
    opacity: 1;
  }
}

.card-item {
  display: flex;
  /* padding: 2px; */
  background:var(--cinza-claro);
  border: 1px var(--cinza-escuro) solid;
  border-radius: var(--border-radius-padrao);
  z-index: 155;
  min-height: 50px;
  width: 100%;
}

.card-item-descricao {
  padding-block: 5px;
  max-height: 100%;
}

.card-item-quantidade {
  font-weight: bold;
  color: darkblue;
  font-size: 12px;
}

.card-item-quantidade>p{
  font-size: 12px;
}

.card-item-precos {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding-block: 1px;
}
.card-item-precos > div {
  width: 100%;
  align-items: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-item-precos > div > .container-un-to {
  border-radius: var(--border-radius-padrao);
  padding-inline: 2px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  text-align: start;
  justify-content: center;
  color: white;
  min-width: 18px;
}
.card-item-precos > div > p {
  width: 75%;
  text-align: start;
  font-size: 12px;
  margin-inline: 5px;
  letter-spacing: -1px;
  font-weight: bold;
}

.card-item-btn-excluir {
  display: flex;
  margin: 1px;
  background: var(--cor-vermelho);
  min-height: 35px;
  border-radius: var(--border-radius-padrao);
}

.card-item-btn-excluir img {
  object-fit: contain;
}

.card-item-btn-editar {
  display: flex;
  margin: 1px;
  margin-right: 2px;
  background: var(--azul-claro);
  min-height: 35px;
  border-radius: var(--border-radius-padrao);
}

.card-item-btn-editar img {
  object-fit: contain;
}


.img-trash {
  position: relative;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  flex-grow: 1;
  filter: invert(100%);
  max-height: 20px;
  min-height: 5px;
}

.texto-sem {
  font-size: 10px;
  text-align: start;
  margin-top: 5px;
  color: darkblue;
}
.texto-sem>div>p{
  font-size: 10px;
}

h3 {
  color: black;
}

h4 {
  color: black;
  text-align: left;
  margin-inline: 0;
}

.bottom-bar-row {
  width: 100%;
  display: block;
}

.texto-desabilitado-anim {
  animation: animTextoDesab 0.3s linear forwards;
}
@keyframes animTextoDesab {
  0% {
    transform: scaleX(80%);
  }
  100% {
    transform: scaleX(100%);
  }
}
</style>
